import { useTranslation } from "react-i18next";

import { getVlessSubscriptionUrl } from "../../utils/vlessSubscription";

import styles from "./guides.module.css";

const GuideVlessLinkData = ({ subscription, label }) => {
  const { t } = useTranslation();
  const hasLabel = (label || "").trim() !== "";
  const resolvedLabel = (label || "").trim() || t("Subscription link");
  const subscriptionUrl = getVlessSubscriptionUrl(subscription);

  if (!subscriptionUrl) {
    return null;
  }

  return (
    <div
      className={`${styles.container} ${
        hasLabel ? styles["with-label"] : styles["without-label"]
      }`}
    >
      <div className={styles.row}>
        {hasLabel ? (
          <div className={`${styles.wrap} label mb-025`}>{resolvedLabel}</div>
        ) : (
          <></>
        )}
        <div className={`${styles.wrap} bold`}>{subscriptionUrl}</div>
      </div>
    </div>
  );
};

export default GuideVlessLinkData;

